module.exports = __webpack_public_path__ + "static/media/computer_Overview.d2b87c40.png";